import React, { useEffect, useState } from 'react';
import instance from '../../Config/AxiosConfig';
import axios from 'axios';
import Cookies from 'js-cookie';
import { Modal, Button } from 'react-bootstrap';

function StepOne({ formNumber, handleNext, handleBack }) {
    const [formData, setFormData] = useState({
        firstName: "",
        lastName: '',
        orcid: '',
        gender: '',
        universityName: '',
        department: '',
        email: '',
        password: '',
        confirmPassword: '',
        termes: 0,
    });

    useEffect(() => {
        const userId = localStorage.getItem('userId');
        if (userId) {
            axios.get(`https://go.vecos.us/reunice/API/v1/users/get/${userId}/data`)
                .then(res => {
                    setFormData({
                        firstName: res.data.firstName || "",
                        lastName: res.data.lastName || '',
                        orcid: res.data.orcid || '',
                        gender: res.data.gender || '',
                        universityName: res.data.universityName || '',
                        department: res.data.department || '',
                        email: res.data.email || '',
                        termes: res.data.termes || 0,
                        password: '',
                        confirmPassword: '',
                        Id: userId,
                    });
                });
        }
    }, []);

    const handleChange = (e) => {
        const { name, value, type, checked } = e.target;
        if (type === 'checkbox') {
            setFormData({
                ...formData,
                [name]: checked ? 1 : 0
            });
            if (name === 'termes' && checked) {
                handleShow();
            }
        } else {
            setFormData({
                ...formData,
                [name]: value
            });
        }
    };

    const [errors, setErrors] = useState({});
    const handleRegister = async (e) => {
        e.preventDefault();
        if (!formData.termes) {
            setErrors({ termes: 'You must accept the terms and conditions.' });
            return null;
        }
        try {
            let data = formData;
            const response = await instance.post('/users/register', data);
            if (response.status === 200 && response.data.token) {
                const token = response.data.token;
                const userId = response.data.id;
                Cookies.set('token', token);
                Cookies.set('userId', userId);
                return response.data;
            } else {
                setErrors(response.data.error || {});
                return response.data;
            }
        } catch (error) {
            console.error('Response error:', error);
            
        }
    };

    const [university, setUniversity] = useState([]);
    const [department, setDepartment] = useState([]);

    useEffect(() => {
        axios.get("https://go.vecos.us/reunice/API/v1/Universitys/getAll")
            .then(response => {
                setUniversity(response.data);
            })
            .catch(error => {
                console.error('Erreur lors de la récupération des données:', error);
            });
    }, []);

    useEffect(() => {
        axios.get("https://go.vecos.us/reunice/API/v1/departments/getAll")
            .then(response => {
                setDepartment(response.data);
            })
            .catch(error => {
                console.error('Erreur lors de la récupération des données:', error);
            });
    }, []);

    const handleRegisterWithNext = async (e) => {
        try {
            const data = await handleRegister(e);
            if (data && data.token) {
                handleNext();
            } else {
                console.error('Registration failed', data ? data.error : ' error');
            }
        } catch (error) {
            console.error('Registration failed', error);
        }
    };

    const [passwordType, setPasswordType] = useState('password');
    const [eyeIcon, setEyeIcon] = useState('fa-eye-slash');

    const togglePasswordVisibility = () => {
        if (passwordType === 'password') {
            setPasswordType('text');
            setEyeIcon('fa-eye');
        } else {
            setPasswordType('password');
            setEyeIcon('fa-eye-slash');
        }
    };

    const [show, setShow] = useState(false);

    const handleClose = () => setShow(false);
    const handleShow = () => setShow(true);

    return (
        <>
            <form className="mt-4" onSubmit={handleRegisterWithNext}>
            <div className=" row mb-3 d-flex align-items-center">
                    <div className=" col-md-6  input-group-lg ">
                        <label for="firstName" className="form-label ">FirstName <span className='text-danger fs-4'>*</span></label>
                        <input id="firstName"
                            type="text"
                            className="form-control"
                            // placeholder="First Name"
                            name="firstName"
                            value={formData.firstName}
                            onChange={handleChange}
                            required
                        />
                        {errors &&
                            <span className='text-danger mt-3'>{errors.firstName}</span>
                        }
                    </div>
                    <div className="  col-md-6 input-group-lg">
                        <label for="lastName" className="form-label ">LastName <span className='text-danger fs-4'>*</span></label>
                        <input id="lastName"
                            type="text"
                            className="form-control"
                            // placeholder="Last Name"
                            name="lastName"
                            value={formData.lastName}
                            onChange={handleChange}
                            required
                        />
                        {errors &&
                            <span className='text-danger mt-3'>{errors.lastName}</span>
                        }
                    </div>
                </div>

                <div className=" row mb-3 d-flex align-items-center">
                    <div className=" col-md-6 input-group-lg ">
                        <label for="gender" className="form-label ">Gender <span className='text-danger fs-4'>*</span></label>
                        <select id="gender"
                            className="form-select js-choice"
                            name="gender"
                            value={formData.gender}
                            onChange={handleChange}
                            required
                        >

                            <option value="">Select gender</option>
                            <option value="F">Female</option>
                            <option value="M">Male</option>
                            <option value="M">Other</option>
                        </select>
                        {errors &&

                            <span className='text-danger mt-3'>{errors.gender}</span>
                        }

                    </div>





                    <div className="col-md-6 input-group-lg">
                        <label for="orcid" className="form-label ">ORCID <span className='text-white fs-4'>*</span></label>

                        <input id="orcid"
                            type="text"
                            className="form-control"
                            // placeholder="ORCID CODE"
                            name="orcid"
                            value={formData.orcid}
                            onChange={handleChange}
                        // required
                        />
                        {errors &&
                            <span className='text-danger mt-3'>{errors.orcid}</span>
                        }
                    </div>
                </div>

                <div className=" row mb-3 d-flex align-items-center">
                    <div className=" col-md-6 input-group-lg">
                        <label for="universityName" className="form-label ">University Name <span className='text-danger fs-4'>*</span></label>

                        <select id="universityName" name="universityName" onChange={handleChange} class="form-select " required>

                            <option value={formData.lenght > 0 ? formData.universityName :""} >{formData.lenght > 0 ? formData.universityName : "Select university"}</option>

                            {
                                university.map((c, i) => {

                                    return (

                                        <option key={i} value={c.acronym}>{c.name}</option>
                                    )
                                })
                            }

                        </select>
                        {errors &&
                            <span className='text-danger mt-3'>{errors.universityName}</span>
                        }
                    </div>


                    <div className="col-md-6 input-group-lg ">
                        <label for="Department" className="form-label ">Department <span className='text-white fs-4'>*</span></label>

                        <input type="text" id="Department" className="form-control"
                            placeholder="Department"
                            name="department"

                            value={formData.department}
                            onChange={handleChange}
                        // required
                        />
                        {errors &&
                            <span className='text-danger mt-3'>{errors.department}</span>
                        }

                    </div>
                </div>

                <div className=" row mb-3 d-flex align-items-center">
                    <div className="input-group-lg me-3 flex-grow-1">
                        <label for="email" className="form-label ">Email<span className='text-danger fs-4'>*</span></label>

                        <input
                            type="email"
                            className="form-control"
                            placeholder="Enter email"
                            name="email"
                            value={formData.email}
                            onChange={handleChange}
                            required
                        />
                        {errors &&
                            <span className='text-danger mt-3'>{errors.email}</span>
                        }
                    </div>
                </div>

                <div className=" row mb-3 d-flex align-items-center">
                    <div className=" col-md-6 input-group-lg">

                        <label for="psw-input" className="form-label ">Password<span className='text-danger fs-4'>*</span></label>
                        <div className="input-group">
                            <input
                                className="form-control fakepassword"
                                id="psw-input"
                                name="password"
                                value={formData.password}

                                type={passwordType}

                                placeholder="Enter new password"
                                onChange={handleChange}
                                required
                            />
                            <span className="input-group-text p-0" onClick={togglePasswordVisibility}>
                                <i className={`fakepasswordicon fa-solid ${eyeIcon} cursor-pointer p-2 w-40px`}></i>
                            </span>
                        </div>



                    </div>
                    <div className="col-md-6 input-group-lg ">

                        <label for="confirmPassword" className="form-label ">confirm Password<span className='text-danger fs-4'>*</span></label>

                        <input
                            id="confirmPassword"
                            type="password"
                            className="form-control"
                            placeholder="Confirm password"
                            name="confirmPassword"
                            value={formData.confirmPassword}
                            onChange={handleChange}
                            required
                        />
                    </div>



                </div>
                {errors &&
                    <span className='text-danger my-3'>{errors.password}</span>
                }
                {errors &&
                    <span className='text-danger my-3'>{errors.confirmPassword}</span>
                }

<div className="col-12">
    <label className="form-label">About</label>
    <textarea
        className="form-control"
        placeholder="Describe yourself here..."
        name="about"
        value={formData.about}
        onChange={handleChange}
        
        style={{ height: 'auto' }}
        rows={3}  // Définit le nombre de lignes initiales
    />
    {errors && <span className='text-danger mt-3'>{errors.about}</span>}
</div>
                <div className="d-flex justify-content-left">
                    <div className="form-check">
                        <input
                            className="form-check-input"
                            type="checkbox"
                            id="gridCheck"
                            name="termes"
                            checked={formData.termes === 1}
                            onChange={handleChange}
                            required
                        />
                        <label className="form-check-label" htmlFor="gridCheck">
                            Terms and conditions
                        </label>
                    </div>
                </div>
                {errors && <span className='text-danger mt-3'>{errors.termes}</span>}
                <div className="d-flex justify-content-between mt-3">
                    <button type="submit" className="btn btn-sm btn-primary">Next</button>
                </div>
            </form>

            <Modal show={show} onHide={handleClose} className="custom-modal" profi>
                <Modal.Header closeButton>
                    <Modal.Title>Terms and conditions</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <p><strong>Terms and Conditions for Using Open REUNICE</strong></p>

                    <p><strong>1. Introduction</strong> Welcome to Open REUNICE, a platform designed to facilitate collaboration among researchers through AI-driven matching based on specific research axes. By accessing or using our platform, you agree to be bound by these terms and conditions.</p>

                    <p><strong>2. Definitions</strong></p>
                    <ul>
                        <li><strong>Platform:</strong> Refers to Open REUNICE.</li>
                        <li><strong>User:</strong> Any individual who accesses or uses the Platform.</li>
                        <li><strong>Personal Data:</strong> Any information that relates to an identified or identifiable individual, including but not limited to name, contact information, research interests, and professional background.</li>
                        <li><strong>AI Matching:</strong> The process of using artificial intelligence algorithms to match researchers with similar or complementary research interests.</li>
                    </ul>

                    <p><strong>3. Consent to Use Personal Data</strong> By using the Platform, you consent to the collection, use, and processing of your Personal Data for the purpose of AI Matching. This includes:</p>
                    <ul>
                        <li>Collecting your Personal Data during the registration process and through subsequent interactions with the Platform.</li>
                        <li>Using your Personal Data to identify potential research collaborators based on specified research axes.</li>
                        <li>Sharing your Personal Data with other users on the Platform to facilitate collaboration.</li>
                    </ul>

                    <p><strong>4. Data Collection and Usage</strong></p>
                    <ul>
                        <li><strong>Types of Data Collected:</strong> We collect Personal Data such as your name, email address, institution, research interests, publications, and any other information you provide.</li>
                        <li><strong>Purpose of Data Collection:</strong> Your Personal Data is collected to enhance the matching process and improve collaboration opportunities.</li>
                        <li><strong>Data Retention:</strong> Your Personal Data will be retained for as long as your account is active or as needed to provide you with the services. You can request deletion of your data at any time by contacting us.</li>
                    </ul>

                    <p><strong>5. Privacy and Security</strong></p>
                    <ul>
                        <li><strong>Data Protection:</strong> We are committed to protecting your Personal Data and use appropriate technical and organizational measures to safeguard it.</li>
                        <li><strong>Third-Party Access:</strong> Your Personal Data will not be shared with third parties without your explicit consent, except as required by law.</li>
                    </ul>

                    <p><strong>6. User Responsibilities</strong></p>
                    <ul>
                        <li><strong>Accuracy of Information:</strong> You agree to provide accurate and complete information when registering and using the Platform.</li>
                        <li><strong>Confidentiality:</strong> You agree to keep confidential any information accessed through the Platform that is not publicly available.</li>
                        <li><strong>Compliance with Laws:</strong> You agree to use the Platform in compliance with all applicable laws and regulations.</li>
                    </ul>

                    <p><strong>7. Intellectual Property</strong> All content on the Platform, including but not limited to text, graphics, logos, and software, is the property of UPHF or its licensors and is protected by intellectual property laws. You may not use any content without prior written permission.</p>

                    <p><strong>8. Limitation of Liability</strong> Open REUNICE is not responsible for any damages arising from the use of the Platform or the AI Matching process. We do not guarantee the accuracy or completeness of the matches provided.</p>

                    <p><strong>9. Changes to Terms and Conditions</strong> We reserve the right to modify these terms and conditions at any time. Any changes will be posted on the Platform, and your continued use of the Platform constitutes acceptance of the revised terms.</p>

                    <p><strong>10. Contact Information</strong> If you have any questions or concerns about these terms and conditions or the use of your Personal Data, please contact us at <a href="mailto:makram.mestiri@uphf.fr">makram.mestiri@uphf.fr</a>.</p>

                    <p>By clicking "I Agree" or by using the Platform, you acknowledge that you have read, understood, and agree to be bound by these terms and conditions.</p>
                </Modal.Body>
                <Modal.Footer>
                    <Button variant="secondary" onClick={handleClose}>
                        OK
                    </Button>
                </Modal.Footer>
            </Modal>
        </>
    );
}

export default StepOne;
